import { render, staticRenderFns } from "./studyCollection.vue?vue&type=template&id=36cca35d&scoped=true"
import script from "./studyCollection.vue?vue&type=script&lang=js"
export * from "./studyCollection.vue?vue&type=script&lang=js"
import style0 from "./studyCollection.vue?vue&type=style&index=0&id=36cca35d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cca35d",
  null
  
)

export default component.exports